import { useTranslation } from "react-i18next";

import { CartographyRow } from "src/brand/EC/components/folder/cartography/CartographyRow";
import { useFolderCartographieTabEC } from "src/brand/EC/hooks/folder/cartography/useFolderCartographyTab";
import IconActivity from "src/core/assets/images/radar/activity.svg?react";
import IconClient from "src/core/assets/images/radar/client.svg?react";
import IconLocation from "src/core/assets/images/radar/location.svg?react";
import IconMission from "src/core/assets/images/radar/mission.svg?react";

export const CartographyTable = () => {
  const { t } = useTranslation();

  const {
    activityEntry,
    corporationEntry,
    clientEntry,
    cartographyRisks,
    stakeholders,
    entities,
    tabRiskLevels,
    missions,
    isPPH,
  } = useFolderCartographieTabEC();

  return (
    <div className="flex flex-col gap-10 mt-20 mb-20">
      {/* Activité */}
      <div className="cartography-table-row" data-testid="cartography-activity-row">
        <CartographyRow
          key="activity"
          icon={<IconActivity />}
          branchLabel={t("folder.cartographie.activite")}
          branchRisk={cartographyRisks.activity}
          detailLabel={activityEntry.label}
        />
      </div>
      {/* Localisation */}
      <div className="cartography-table-row" data-testid="cartography-location-row">
        {!isPPH ? (
          <>
            <CartographyRow
              key="location"
              icon={<IconLocation />}
              branchLabel={t("folder.cartographie.localisation")}
              branchRisk={cartographyRisks.location}
              isHeader={true}
              criteriaRisk={corporationEntry.risk}
              detailLabel={corporationEntry.label}
            />

            {stakeholders.map((stakeholder) => (
              <CartographyRow
                key={`stakeholder-${stakeholder.key}`}
                criteriaRisk={stakeholder.riskLevel}
                detailLabel={stakeholder.fullName}
              />
            ))}
          </>
        ) : (
          stakeholders.map((stakeholder) => (
            <CartographyRow
              key={`stakeholder-${stakeholder.key}`}
              criteriaRisk={stakeholder.riskLevel}
              detailLabel={stakeholder.fullName}
              icon={<IconLocation />}
              branchLabel={t("folder.cartographie.localisation")}
              branchRisk={stakeholder.riskLevel}
            />
          ))
        )}
      </div>
      {/* Client */}
      <div className="cartography-table-row" data-testid="cartography-client-row">
        {!isPPH ? (
          <>
            <CartographyRow
              key="client"
              icon={<IconClient />}
              branchLabel={t("folder.cartographie.client")}
              branchRisk={cartographyRisks.client}
              isHeader={true}
              criteriaRisk={clientEntry.risk}
              detailLabel={clientEntry.label}
            />
            <CartographyRow
              key="questionnaire"
              isHeader={false}
              criteriaRisk={tabRiskLevels.questionnaire}
              detailLabel={t("folder.cartographie.questionnaireLAB")}
            />
          </>
        ) : (
          <CartographyRow
            key="questionnaire"
            isHeader={false}
            criteriaRisk={tabRiskLevels.questionnaire}
            detailLabel={t("folder.cartographie.questionnaireLAB")}
            icon={<IconClient />}
            branchLabel={t("folder.cartographie.client")}
            branchRisk={cartographyRisks.client}
          />
        )}

        {entities.map((entity) => {
          const alertTypes = entity.alertType ?? [];
          const alertLabel =
            (alertTypes.length > 0
              ? alertTypes.map((type) => t(`folder.cartographie.${type}`)).join(" / ") + " : "
              : "") + entity.fullName;

          return (
            <CartographyRow
              key={`entity-${entity.key}`}
              criteriaRisk={entity.riskLevel}
              detailLabel={alertLabel}
            />
          );
        })}
      </div>
      {/* Mission */}
      <div className="cartography-table-row" data-testid="cartography-mission-row">
        <CartographyRow
          key="mission"
          icon={<IconMission />}
          branchLabel={t("folder.cartographie.mission")}
          branchRisk={cartographyRisks.mission}
          criteriaRisk={missions.length > 1 ? missions[0]?.risk : undefined}
          detailLabel={missions[0]?.label}
        />

        {missions.slice(1).map((mission, index) => (
          <CartographyRow
            key={`mission-${index}`}
            detailLabel={mission.label}
            criteriaRisk={mission.risk}
          />
        ))}
      </div>
    </div>
  );
};
